import { Pipe, PipeTransform } from "@angular/core";

/**
 * Group generic array by id device entry property
 */
@Pipe({
    name: "groupByIdDevice",
    standalone: false
})
export class GroupByIdDevicePipe implements PipeTransform {
  transform(listGeneric: Array<any>, ...args: unknown[]): object {
    let returnObject: object = null;
    if (listGeneric.length) {
      returnObject = {};

      listGeneric.map((currentEntry: any) => {
        const keyDevice: number = currentEntry.idDevice;

        if (!returnObject[keyDevice]) {
          returnObject[keyDevice] = new Array<any>();
        }

        returnObject[keyDevice].push(currentEntry);

        return currentEntry;
      });
    }

    return returnObject;
  }
}
